document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.shoppable-carousel').forEach(function (carousel) {
    const track = carousel.querySelector('.shoppable-carousel__track');
    const dots = carousel.querySelectorAll('.shoppable-carousel__dot');
    const slides = carousel.querySelectorAll('.shoppable-carousel__slide');

    if (!track || !slides.length) return;

    // ============================
    // CARROUSEL HORIZONTAL (peek)
    // ============================
    let soundOn = false;
    let activeIndex = 0;

    function getVideo(slide) {
      return slide.querySelector('video');
    }

    function syncIcon(slide) {
      const video = getVideo(slide);
      const btn = slide.querySelector('[data-mute-toggle]');
      if (!btn) return;
      const iconUnmuted = btn.querySelector('[data-icon-unmuted]');
      const iconMuted = btn.querySelector('[data-icon-muted]');
      const isMuted = video ? video.muted : true;
      if (iconUnmuted && iconMuted) {
        iconUnmuted.style.display = isMuted ? 'none' : 'block';
        iconMuted.style.display = isMuted ? 'block' : 'none';
      }
    }

    function applyAudioState() {
      slides.forEach(function (slide, i) {
        const video = getVideo(slide);
        if (!video) return;
        video.muted = !(soundOn && i === activeIndex);
        syncIcon(slide);
      });
    }

    function updateActiveSlide() {
      const trackRect = track.getBoundingClientRect();
      const trackCenter = trackRect.left + trackRect.width / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function (slide, i) {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.left + rect.width / 2;
        const distance = Math.abs(trackCenter - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
        slide.classList.remove('is-active');
      });

      slides[closestIndex].classList.add('is-active');
      activeIndex = closestIndex;

      if (dots.length) {
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === closestIndex));
      }

      applyAudioState();
    }

    let scrollTimeout;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(updateActiveSlide, 100);
    });

    window.addEventListener('resize', updateActiveSlide);
    updateActiveSlide();

    carousel.querySelectorAll('.shoppable-carousel__slide [data-mute-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const slide = btn.closest('.shoppable-carousel__slide');
        const slideIndex = Array.prototype.indexOf.call(slides, slide);

        if (slideIndex !== activeIndex) {
          slides.forEach((s) => s.classList.remove('is-active'));
          slide.classList.add('is-active');
          activeIndex = slideIndex;
          if (dots.length) {
            dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
          }
        }

        soundOn = !soundOn;
        applyAudioState();
      });
    });

    // Empêche le clic sur la carte produit d'ouvrir le plein écran
    carousel.querySelectorAll('[data-product-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });

    // Ajout au panier via AJAX Shopify (fonctionne pour toutes les cartes, mini + plein écran)
    function bindAddToCart(root) {
      root.querySelectorAll('[data-add-to-cart]').forEach(function (btn) {
        if (btn.dataset.bound) return;
        btn.dataset.bound = 'true';
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          const variantId = btn.getAttribute('data-variant-id');
          if (!variantId) return;

          btn.disabled = true;
          const originalHTML = btn.innerHTML;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          })
            .then((res) => res.json())
            .then(() => {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              btn.innerHTML = '✓';
            })
            .catch((err) => console.error('Erreur ajout panier', err))
            .finally(() => {
              setTimeout(() => {
                btn.innerHTML = originalHTML;
                btn.disabled = false;
              }, 1500);
            });
        });
      });
    }
    bindAddToCart(carousel);

    // ============================
    // MODE PLEIN ECRAN (style TikTok)
    // ============================
    const fullscreen = carousel.querySelector('[data-fullscreen]');
    if (!fullscreen) return;

    const fsTrack = fullscreen.querySelector('[data-fs-track]');
    const fsSlides = fullscreen.querySelectorAll('.shoppable-carousel__fs-slide');
    bindAddToCart(fullscreen);

    let fsSoundOn = true;
    let fsActiveIndex = 0;

    function fsGetVideo(slide) {
      return slide.querySelector('video');
    }

    function fsSyncIcon(slide) {
      const video = fsGetVideo(slide);
      const btn = slide.querySelector('[data-fs-mute-toggle]');
      if (!btn) return;
      const iconUnmuted = btn.querySelector('[data-icon-unmuted]');
      const iconMuted = btn.querySelector('[data-icon-muted]');
      const isMuted = video ? video.muted : true;
      if (iconUnmuted && iconMuted) {
        iconUnmuted.style.display = isMuted ? 'none' : 'block';
        iconMuted.style.display = isMuted ? 'block' : 'none';
      }
    }

    function fsActivate(index) {
      fsSlides.forEach(function (slide, i) {
        const video = fsGetVideo(slide);
        if (!video) return;

        if (i === index) {
          video.currentTime = 0;
          video.muted = !fsSoundOn;
          const playPromise = video.play();
          if (playPromise && playPromise.catch) {
            playPromise.catch(function () {
              video.muted = true;
              video.play().catch(function () {});
              fsSyncIcon(slide);
            });
          }
        } else {
          video.pause();
        }
        fsSyncIcon(slide);
      });
      fsActiveIndex = index;
    }

    function fsUpdateActiveFromScroll() {
      const containerRect = fsTrack.getBoundingClientRect();
      const containerCenter = containerRect.top + containerRect.height / 2;

      let closestIndex = 0;
      let closestDistance = Infinity;

      fsSlides.forEach(function (slide, i) {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.top + rect.height / 2;
        const distance = Math.abs(containerCenter - slideCenter);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      if (closestIndex !== fsActiveIndex) {
        fsActivate(closestIndex);
      }
    }

    let fsScrollTimeout;
    fsTrack.addEventListener('scroll', function () {
      clearTimeout(fsScrollTimeout);
      fsScrollTimeout = setTimeout(fsUpdateActiveFromScroll, 100);
    });

    function openFullscreen(index) {
      fullscreen.hidden = false;
      document.body.classList.add('shoppable-carousel-no-scroll');
      fsTrack.scrollTop = index * fsTrack.clientHeight;
      fsSoundOn = true;
      fsActivate(index);
    }

    function closeFullscreen() {
      fullscreen.hidden = true;
      document.body.classList.remove('shoppable-carousel-no-scroll');
      fsSlides.forEach(function (slide) {
        const video = fsGetVideo(slide);
        if (video) video.pause();
      });
    }

    // Clic sur une vidéo/image de la mini-slide -> ouverture plein écran
    carousel.querySelectorAll('.shoppable-carousel__slide [data-open-fullscreen]').forEach(function (media) {
      media.addEventListener('click', function () {
        const slide = media.closest('.shoppable-carousel__slide');
        const index = parseInt(slide.getAttribute('data-index'), 10) || 0;
        openFullscreen(index);
      });
    });

    // Bouton fermer
    fullscreen.querySelectorAll('[data-fs-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeFullscreen();
      });
    });

    // Bouton son (plein écran)
    fullscreen.querySelectorAll('[data-fs-mute-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const slide = btn.closest('.shoppable-carousel__fs-slide');
        const video = fsGetVideo(slide);
        if (!video) return;
        fsSoundOn = !fsSoundOn;
        video.muted = !fsSoundOn;
        fsSyncIcon(slide);
      });
    });

    // Like (visuel uniquement)
    fullscreen.querySelectorAll('[data-fs-like]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const countEl = btn.querySelector('[data-fs-like-count]');
        const baseLikes = parseInt(btn.getAttribute('data-base-likes'), 10) || 0;
        const isLiked = btn.classList.toggle('is-liked');
        if (countEl) {
          countEl.textContent = isLiked ? baseLikes + 1 : baseLikes;
        }
      });
    });

    // Partage
    fullscreen.querySelectorAll('[data-fs-share]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        const url = btn.getAttribute('data-url') || window.location.href;
        if (navigator.share) {
          navigator.share({ url: url }).catch(function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).catch(function () {});
        }
      });
    });

    // Empêche le clic sur la carte produit en plein écran de re-déclencher quoi que ce soit
    fullscreen.querySelectorAll('[data-product-card]').forEach(function (card) {
      card.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    });
  });
});